module.exports = __webpack_public_path__ + "img/invoice.f8d5007a.png";